import _defineProperty from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
var _excluded = ["asChild"];
import { Slot as e } from "@radix-ui/react-slot";
import * as r from "react";
import i from "@babel/runtime/helpers/esm/extends";
export var Primitive = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "p", "span", "svg", "ul"].reduce(function (t, s) {
  return _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, s, /*#__PURE__*/r.forwardRef(function (t, n) {
    var a = t.asChild,
      m = _objectWithoutProperties(t, _excluded),
      d = a ? e : s;
    return r.useEffect(function () {
      window[Symbol.for("radix-ui")] = !0;
    }, []), t.as && console.error(o), /*#__PURE__*/r.createElement(d, i({}, m, {
      ref: n
    }));
  })));
}, {});
var o = "Warning: The `as` prop has been removed in favour of `asChild`. For details, see https://radix-ui.com/docs/primitives/overview/styling#changing-the-rendered-element";
export var Root = Primitive;